var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",attrs:{"method":"post","action":"/logout"}},[_c('input',{attrs:{"type":"hidden","name":"_csrf"},domProps:{"value":_vm.csrf}})])
}
var staticRenderFns = []

export { render, staticRenderFns }